import { Injectable, inject } from '@angular/core';

import { TenantDto } from '@nusign/picflow-backend-types';
import { BrowserService } from '../../services/browser.service';
import { PublicTenantService } from '../../services/public-tenant.service';
import { PwaService } from '../../services/pwa.service';
import { TenantGoogleAnalyticsService } from '../../services/tenant-google-analytics.service';
import { TenantGoogleTagmanagerService } from '../../services/tenant-google-tagmanager.service';

@Injectable({
  providedIn: 'root',
})
export class TenantProfileResolve {
  private publicTenantService = inject(PublicTenantService);
  private browserService = inject(BrowserService);
  private tenantGoogleAnalytics = inject(TenantGoogleAnalyticsService);
  private tenantGoogleTagManager = inject(TenantGoogleTagmanagerService);
  private pwaService = inject(PwaService); // just here to catch beforeinstall event

  async resolve() {
    const subDomain = this.browserService.getTenantSubDomain();
    const customDomain = this.browserService.getTenantCustomDomain();
    if (!subDomain && !customDomain) return;
    let tenant: TenantDto;

    try {
      if (customDomain) {
        tenant = await this.publicTenantService.getTenantFromCustomDomain(customDomain);
      } else {
        tenant = await this.publicTenantService.getTenant(subDomain);
      }
    } catch (err) {
      console.error(err);
    }

    if (!tenant) return;

    if (tenant.block_public_link_access) {
      return;
    }

    if (tenant?.id_ga) {
      this.tenantGoogleAnalytics.load(tenant.id_ga);
    }
    if (tenant?.id_gtm) {
      this.tenantGoogleTagManager.load(tenant.id_gtm);
    }
    return tenant;
  }
}
